import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Reason } from 'contracts/Reasons';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_REASON_',
  }
);

export interface FetchReasonState {
  data: Reason | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchReasonRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Reason;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchReasonState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchReasonState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchReasonState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchReasonState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchReasonState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchReason = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchReasonTypes = Types;
export const FetchReasonActions = Creators;
